import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { submitCallbackRequest as callbackRequest } from '@fttb/common/store';
import { captureException } from '@fttb/common/components';
import { selectIsCheckboxChecked } from "../../CheckboxAgreement/selectors";
import { EMPTY_CTN, IS_NOT_CHECKED_AGREEMENT } from "../constants";
import { selectCaptchaData, selectIsFttbPersonalVerificationCheckboxEnable, selectUserCtn } from "../selectors";
export var submitCallbackRequest = createAsyncThunk('callbackRequest/submitCallbackRequest', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, _ref) {
    var getState, rejectWithValue, state, ctn, isCheckboxChecked, captchaData, isPersonalVerificationCheckboxEnable;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getState = _ref.getState, rejectWithValue = _ref.rejectWithValue;
          state = getState();
          ctn = selectUserCtn(state);
          isCheckboxChecked = selectIsCheckboxChecked(state);
          captchaData = selectCaptchaData(state);
          isPersonalVerificationCheckboxEnable = selectIsFttbPersonalVerificationCheckboxEnable(state);
          _context.prev = 6;
          if (!(ctn.length !== 10)) {
            _context.next = 9;
            break;
          }
          throw new Error(EMPTY_CTN);
        case 9:
          if (!(!isCheckboxChecked && isPersonalVerificationCheckboxEnable)) {
            _context.next = 11;
            break;
          }
          throw new Error(IS_NOT_CHECKED_AGREEMENT);
        case 11:
          _context.next = 13;
          return callbackRequest({
            caseTitle: 'sale',
            phoneNumber: "+7".concat(ctn),
            captchaData: captchaData
          });
        case 13:
          return _context.abrupt("return", _context.sent);
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](6);
          captureException(_context.t0);
          if (!(_context.t0 instanceof Error)) {
            _context.next = 21;
            break;
          }
          return _context.abrupt("return", rejectWithValue(_context.t0.message));
        case 21:
          throw new Error();
        case 22:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[6, 16]]);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());